// src/App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import Sidebar from './components/Sidebar';
import App1 from './components/App1';
import App2 from './components/App2';
import App3 from './components/App3';
import App4 from './components/App4';
import App5 from './components/App5';
import ManageUsers from './components/ManageUsers';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPainel'; // seu painel já criado
import './App.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <Sidebar />
      <div className="content">{children}</div>
    </div>
  );
}

function App() {
  // 1) Lê do localStorage para saber se está logado e se é admin
  const storedPerms = localStorage.getItem('userPermissoes');
  let permissoes = [];
  if (storedPerms) {
    try {
      permissoes = JSON.parse(storedPerms);
    } catch {
      permissoes = [storedPerms];
    }
  }

  const isAuthenticated = Boolean(localStorage.getItem('userEmail'));
  const isAdmin = permissoes.includes('admin');

  return (
    <Router>
      <Routes>
        {/* 2) Rota de Login */}
        <Route path="/" element={<Login />} />

        {/* 3) Dashboard (sem Sidebar) */}
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <Dashboard />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* 4) Rotas “com Layout” */}
        <Route
          path="/app1"
          element={
            isAuthenticated ? (
              <Layout>
                <App1 />
              </Layout>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/app2"
          element={
            isAuthenticated ? (
              <Layout>
                <App2 />
              </Layout>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/app3"
          element={
            isAuthenticated ? (
              <Layout>
                <App3 />
              </Layout>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/app4"
          element={
            isAuthenticated ? (
              <Layout>
                <App4 />
              </Layout>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/app5"
          element={
            isAuthenticated ? (
              <Layout>
                <App5 />
              </Layout>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* 5) Rota existente para “ManageUsers” (porta 5353) */}
        <Route
          path="/manage-users"
          element={
            isAuthenticated && isAdmin ? (
              <Layout>
                <ManageUsers />
              </Layout>
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />

        {/* 6) NOVA ROTA: AdminPanel (porta 7007), só “admin” vê */}
        <Route
  path="/admin-painel"
  element={
    isAuthenticated && isAdmin ? (
      <AdminPanel />
    ) : (
      <Navigate to="/dashboard" replace />
    )
  }
/>

        {/* 7) Rota coringa para "página não encontrada" */}
        <Route path="*" element={<h2>Página não encontrada</h2>} />
      </Routes>
    </Router>
  );
}

export default App;
